import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Snackbar } from "@js/components/snackbar";

import { useGetFreelancerInvitationDetailsQuery } from "../../api";
import { REGISTER_INVITATION_PARAMS } from "../../utils";

export const NEW_FREELANCER_INVITATION_PARAM =
  REGISTER_INVITATION_PARAMS.FREELANCER_INVITATION_KEY;

export const useNewFreelancerSignUpInvitation = () => {
  const [searchParams] = useSearchParams();
  const freelancerInvitationKey = searchParams.get(
    NEW_FREELANCER_INVITATION_PARAM,
  );
  const [isFreelancerInvitation, setIsFreelancerInvitation] = useState(
    Boolean(freelancerInvitationKey),
  );
  const { data, isLoading } = useGetFreelancerInvitationDetailsQuery(
    { key: freelancerInvitationKey as string },
    { skip: !freelancerInvitationKey },
  );

  useEffect(() => {
    if (!isLoading && data?.invitation_error?.length) {
      Snackbar.error(data?.invitation_error, {
        preventDuplicate: true,
      });
      setIsFreelancerInvitation(false);
    }
  }, [data, isLoading]);

  return {
    isFreelancerInvitation,
    newFreelancerInvitationData: data?.invitation_error ? undefined : data,
  };
};
